var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 71,
    viewBox: "0 0 100 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 71,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2",
    transform: "translate(-722.5 -268.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grille_de_r\\xE9p\\xE9tition_1",
    "data-name": "Grille de r\\xE9p\\xE9tition 1",
    transform: "translate(722.5 268.5)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-722.5 -268.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_4",
    "data-name": "Ligne 4",
    x2: 100,
    transform: "translate(722.5 273.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-722.5 -238.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_4-2",
    "data-name": "Ligne 4",
    x2: 100,
    transform: "translate(722.5 273.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-722.5 -208.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Ligne_4-3",
    "data-name": "Ligne 4",
    x2: 100,
    transform: "translate(722.5 273.5)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 10
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleIcon);
export default __webpack_public_path__ + "static/media/toggle-icon.197bcdc70f6468211b64bdbb88142e90.svg";
export { ForwardRef as ReactComponent };